import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTimepickerModule } from '@angular/material/timepicker';
import { RtI18nDirective } from '../runtime-translation.directive';

/**
 * The "Enable Post Communication Digest" checkbox + time picker shared by the profile page and the
 * first-login communication-preferences modal. The host form must contain the controls enableDigest
 * and digestTimeDate; the host owns the wiring between them (enable/disable, default 5 p.m., and
 * mirroring the picked Date into the "HH:mm" string the backend stores).
 */
@Component({
  selector: 'app-communication-digest',
  standalone: true,
  templateUrl: './communication-digest.component.html',
  imports: [ReactiveFormsModule, MatCheckboxModule, MatFormFieldModule, MatInputModule, MatTimepickerModule, RtI18nDirective]
})
export class CommunicationDigestComponent {
  @Input({ required: true }) form!: FormGroup;
}
